import { useMutation, useQuery } from "@tanstack/react-query";
import { instance } from "../instance";

export const useFetchLeaderboard = (filters: FetchLeaderboardPayload) => {
  const fetchLeaderboard = async (): Promise<FetchLeaderboardResponse> => {
    const response = await instance.get(
      `/admin-dashboard/leaderboard?interval=${filters.network==="glo"?"all":filters.interval}&content_id=${filters.content_id}&leaderboard_tab=${filters.leaderboard_tab}&network=${filters.network}&startDate=${filters.start_date}&endDate=${filters.end_date}&main_leaderboard_tab=${filters.main_leaderboard_tab}&game_quiz_id=${filters.game_quiz_id}&download=${filters.download}`
    // "/admin-dashboard/leaderboard?interval=month&startDate=2024-09-19&endDate=2024-09-20&content_id=49"
    );
    if(filters.network==="mtn"){

      return response.data;
    }
    else{


      response.data.data.mainBoard=response?.data?.data?.[filters.main_leaderboard_tab==="score"?"scores":"attempts"]?.map((item:any)=>({...item, "subscriber.display_name":item?.user?.name, "subscriber.user_passport":item?.user?.phone_number, }))
     return response.data.data  
    }
  };
  const queryAPI = useQuery({
    queryKey: ["fetch-leaderboard", filters],
    queryFn: fetchLeaderboard,
  });
  return queryAPI;
};
export const useFetchAllContents = (filters: FetchLeaderboardPayload) => {
  const fetchLeaderboard = async (): Promise<FetchAllContentResponse> => {
    const response = await instance.get(
      `/admin-dashboard/all-content?interval=${filters.interval}&leaderboard_tab=${filters.leaderboard_tab}&network=${filters.network}&startDate=${filters.start_date}&endDate=${filters.end_date}&main_leaderboard_tab=${filters.main_leaderboard_tab}&game_quiz_id=${filters.game_quiz_id}&download=${filters.download}`
    );
  return response.data

  };
  const queryAPI = useQuery({
    queryKey: ["fetch-all-content", filters],
    queryFn: fetchLeaderboard,
  });
  return queryAPI;
};
export const useDownloadLeaderboard = (filters: FetchLeaderboardPayload) => {
  const fetchLeaderboard = async () => {
    const response = await instance.get(
      `/admin-dashboard/leaderboard?interval=${filters.interval}&leaderboard_tab=${filters.leaderboard_tab}&network=${filters.network}&startDate=${filters.start_date}&endDate=${filters.end_date}&main_leaderboard_tab=${filters.main_leaderboard_tab}&game_quiz_id=${filters.game_quiz_id}&download=true`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };
  const queryAPI = useMutation({
    mutationKey: ["fetch-leaderboard"],
    mutationFn: fetchLeaderboard,
  });
  return queryAPI;
};

